import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import 'core-js/es6/map'
import 'core-js/es6/set'
import 'core-js/es6/string'
import 'raf/polyfill'
import './styles/vendor/nucleo/css/nucleo.css'
import './styles/vendor/@fortawesome/fontawesome-free/css/all.min.css'
import './styles/scss/argon-dashboard-react.scss'

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
